<script setup>
import {computed} from "vue";
import {isNumber} from "lodash-es";

import {dotDotDotWhenFalsy} from "@/utils/formatters";
import {parseCellFormatting} from "@/tariffs/cell_formatters";

const props = defineProps({
    cell: {
        type: Object,
        default: () => {
            return {
                input: 12,
                label: 'text here',
                original: 42,
                type: 'difference',
            };
        },
    },
});

const formattedOriginalValue = computed(() => {
    return parseCellFormatting(props.cell.original);
});

const inputValue = computed(() => {
    const value = props.cell.input.content.value;
    if (isNumber(value)) {
        return value
    }
    return null;
});

const formattedDifference = computed(() => {
    if (inputValue.value === null) {
        return {
            result: dotDotDotWhenFalsy(),
        };
    }

    let original = props.cell.original.content;
    if (original && original['value'] !== undefined) {
        original = original.value;
    }

    let diffValue = original - inputValue.value;

    let cls;

    const round = (value) => {
        return +value.toFixed(2);
    };

    if (round(diffValue) > 0) {
        cls = 'text-red-800';
    } else if (round(diffValue) < 0) {
        cls = 'text-green-800';
    }

    let result;
    if (props.cell.input.formatFunc) {
        result = parseCellFormatting({
            content: diffValue,
            formatFunc: props.cell.input.formatFunc,
        })
    }

    return {
        result: result,
        cssClass: cls,
        _diff: diffValue,
        _inputValue: inputValue.value,
        _original: original,
    };
});
</script>

<template>
    <div class="inline-block">
        <div class="mb-1 font- ">
            {{ formattedOriginalValue }}
        </div>
        <div
            class="mb-1 font-semibold"
            :class="formattedDifference.cssClass"
        >
            {{ formattedDifference.result }}
        </div>
        <div class="font-light">{{ props.cell.label }}</div>
    </div>
<!--    <div>-->
<!--        <pre>-->
<!--            <code>{{formattedDifference}}</code>-->
<!--        </pre>-->
<!--    </div>-->
</template>
